var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAtlanticCanadaThumbnailGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#B9BEC6",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 69.5981H82.5888H91L82.5888 63.0561L70.8131 58.3832L64.9252 50.9065H58.1963L46.4206 29.4112L40.5327 32.215L28.757 21L26.2336 23.8037L22.028 29.4112L20.3458 41.5608L17.8224 46.2337H12.7757L10.2523 50.9065V58.3832L2.68224 63.0561L1 69.5981Z",
    fill: "url(#paint0_linear_4784_17820)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6911 55.5805V35.0198L44.7378 44.3656L55.6724 55.5805L73.3359 64.9263L49.7845 63.0572L39.6911 55.5805Z",
    fill: "#F1F2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3463 59.32L17.8229 48.105L22.0285 41.563L25.393 53.7125L40.5332 64.9275H27.9164L20.3463 59.32Z",
    fill: "#F1F2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6914 35.952L29.5979 23.8025L39.6914 55.5782V35.952Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6166 49.0361H17.8223L20.3456 59.3165L5.20543 64.924L11.9344 58.3819L13.6166 49.0361Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4958 64.9279L57.3556 56.5166L60.7201 52.7783H63.2434L75.8603 63.0587L84.2715 64.9279H72.4958Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1426,
    y: 42.001,
    width: 2.45838,
    height: 27.8617,
    rx: 1.22919,
    fill: "#3A3F46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9746,
    y: 42.001,
    width: 2.45838,
    height: 23.7644,
    rx: 1.22919,
    transform: "rotate(90 53.9746 42.001)",
    fill: "#3A3F46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-boat-top",
    x: 51.8965,
    y: 48.0903,
    width: 28.1205,
    height: 15.4663,
    fill: "#818A98"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.8965,
    y: 55.1213,
    width: 35.1506,
    height: 15.4663,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.709,
    y: 57.9329,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "#B9BEC6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.709,
    y: 49.4968,
    width: 22.4964,
    height: 4.21807,
    rx: 0.952838,
    fill: "#B9BEC6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1445,
    y: 57.9329,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "#B9BEC6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5801,
    y: 57.9329,
    width: 5.62409,
    height: 5.62409,
    rx: 0.952838,
    fill: "#B9BEC6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2383,
    y: 45.2788,
    width: 30.9325,
    height: 2.81205,
    rx: 0.952838,
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7773 73.4002C32.7759 74.525 74.3942 66.3701 96.1875 60.043C93.3755 69.0415 89.8604 70.5881 81.4243 81.8363L27.2924 83.2424C26.1676 80.9927 24.7147 78.3213 23.7773 73.4002Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7808 57.9347C77.9086 64.3801 45.0814 68.9559 21.4133 69.8932C19.3043 69.9774 18.6013 71.2988 21.4133 73.4078C24.2254 75.5168 84.9394 67.0805 96.8899 61.4544C99.7019 60.1306 98.9343 56.348 94.7808 57.9347Z",
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9941 69.884C30.3375 72.9303 36.0085 78.7419 39.9453 77.6171C43.8822 76.4923 46.2724 71.0556 46.9755 68.4779C49.0845 71.29 50.288 76.2111 56.8176 76.2111C62.58 76.2111 64.5507 68.4779 64.5507 66.3689",
    stroke: "#D5D8DD",
    strokeWidth: 0.952838,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.91 1.91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7188 43.6399L34.7187 51.015",
    stroke: "#3A3F46",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9853 54.2931C30.5591 54.2931 30.2062 54.6416 30.286 55.0602C30.3884 55.5971 30.5976 56.1107 30.9041 56.5694C31.3543 57.2432 31.9942 57.7684 32.7429 58.0785C33.4916 58.3886 34.3154 58.4697 35.1102 58.3117C35.905 58.1536 36.6351 57.7633 37.2081 57.1903C37.7811 56.6173 38.1714 55.8872 38.3295 55.0924C38.4876 54.2976 38.4064 53.4738 38.0963 52.7251C37.7862 51.9764 37.261 51.3365 36.5872 50.8863C36.1285 50.5798 35.6149 50.3705 35.078 50.2682C34.6594 50.1884 34.3109 50.5413 34.3109 50.9674C34.3109 51.3936 34.664 51.728 35.0709 51.8548C35.3032 51.9272 35.5253 52.0329 35.7298 52.1695C36.1498 52.4502 36.4772 52.849 36.6705 53.3157C36.8638 53.7824 36.9143 54.2959 36.8158 54.7913C36.7172 55.2868 36.474 55.7418 36.1168 56.099C35.7596 56.4562 35.3046 56.6994 34.8092 56.798C34.3137 56.8965 33.8002 56.8459 33.3335 56.6526C32.8669 56.4593 32.468 56.132 32.1873 55.712C32.0507 55.5074 31.945 55.2854 31.8726 55.0531C31.7458 54.6462 31.4114 54.2931 30.9853 54.2931Z",
    fill: "#3A3F46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background",
    d: "M70.1558 78.1321C69.4516 79.7065 68.2771 81.0204 66.4215 82.0855C65.0904 82.8496 64.9956 84.6354 66.4934 84.9704C73.0593 86.4388 84.9315 86.4357 95.7974 81.5189C96.1869 81.3426 96.5029 81.025 96.6198 80.6137C96.8454 79.8197 96.9357 78.9084 96.8965 78.1552C96.7581 75.4922 95.1714 73.5339 93.8309 71.3493C93.6153 70.998 93.1194 71.1708 93.1112 71.583C93.032 75.5406 91.4815 81.4524 85.5672 81.2328C85.4284 81.2277 85.2 81.3895 85.1523 81.2591C85.1096 81.1421 85.2472 81.0321 85.3176 80.9293C86.9337 78.5682 84.9063 75.1711 83.1915 73.1753C82.8631 72.7931 82.347 72.9601 82.3468 73.464C82.3462 75.062 82.3625 76.8927 81.36 78.2345C79.8538 80.2503 77.2552 81.6946 74.8341 82.2455C74.6931 82.2776 72.4801 82.7699 72.4366 82.6186C72.3956 82.4762 72.7176 82.0588 72.7702 81.9089C73.0627 81.0758 73.0676 80.0019 72.7982 79.1645C72.7062 78.8786 72.5674 78.4222 72.3979 77.9086C71.9543 76.5639 70.7339 76.8395 70.1558 78.1321Z",
    fill: "#B9BEC6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0808 83.6373C67.2882 82.4087 69.2855 80.5967 70.244 78.1571C70.7619 76.8392 71.9541 76.5638 72.3977 77.9086C72.5671 78.4221 72.706 78.8785 72.798 79.1645C73.0674 80.0018 73.0624 81.0757 72.77 81.9088C72.7174 82.0587 72.3953 82.4761 72.4363 82.6185C72.4799 82.7699 74.6929 82.2775 74.8339 82.2455C77.2549 81.6945 79.8535 80.2502 81.3597 78.2344C82.3623 76.8926 82.346 75.0619 82.3466 73.4639V73.4639C82.3468 72.96 82.8629 72.793 83.1913 73.1753C84.9061 75.171 86.9335 78.5681 85.3173 80.9292C85.247 81.032 85.1094 81.142 85.1521 81.259V81.259C85.1997 81.3895 85.4282 81.2276 85.5669 81.2328C91.4813 81.4524 93.0318 75.5405 93.111 71.5829C93.1192 71.1708 93.615 70.9979 93.8306 71.3493V71.3493C95.1712 73.5338 96.7579 75.4921 96.8963 78.1551C96.9463 79.1167 96.7853 80.3361 96.401 81.2399",
    stroke: "#D5D8DD",
    strokeWidth: 1.07134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-background",
    d: "M27.4448 78.5966C26.6849 79.7132 25.6224 80.6106 24.1332 81.2792C22.733 81.9079 22.41 83.6504 23.8575 84.1605C29.6464 86.2005 40.0559 87.5174 50.1819 84.5075C50.5917 84.3857 50.9478 84.1133 51.1146 83.7196C51.3997 83.0463 51.5826 82.2641 51.6374 81.6015C51.8367 79.1923 50.6491 77.2402 49.7103 75.1148C49.5593 74.773 49.0928 74.868 49.0354 75.2372C48.4834 78.783 46.3721 83.9057 41.0855 82.9898C40.9614 82.9683 40.7365 83.0859 40.7096 82.963C40.6854 82.8527 40.8224 82.7705 40.8981 82.6867C42.6369 80.7619 41.2283 77.4638 39.9303 75.4625C39.6817 75.0792 39.1978 75.1665 39.1364 75.6192L39.1268 75.69C38.9346 77.1086 38.7164 78.7191 37.6701 79.7849C36.0721 81.4129 33.5621 82.3946 31.3201 82.5954C31.1895 82.6071 29.1416 82.7805 29.1209 82.6393C29.1014 82.5063 29.4414 82.1705 29.5069 82.0422C29.8708 81.3293 30.0057 80.3652 29.8655 79.5802C29.8282 79.3715 29.778 79.0667 29.7152 78.7146C29.4666 77.3205 28.2415 77.426 27.4448 78.5966Z",
    fill: "#B9BEC6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.592 82.4177C24.3463 81.8515 26.3525 80.5616 27.5334 78.6375C28.2742 77.4307 29.4662 77.3205 29.7148 78.7145C29.7776 79.0666 29.8278 79.3714 29.8651 79.5801C30.0053 80.3651 29.8704 81.3292 29.5065 82.0421C29.441 82.1704 29.1009 82.5062 29.1205 82.6392C29.1412 82.7804 31.1891 82.607 31.3197 82.5953C33.5617 82.3945 36.0717 81.4128 37.6697 79.7848C38.7334 78.7012 38.9412 77.0546 39.1359 75.6191V75.6191C39.1974 75.1664 39.6813 75.0791 39.9299 75.4624C41.2279 77.4637 42.6365 80.7618 40.8977 82.6867C40.822 82.7704 40.685 82.8526 40.7092 82.9629V82.9629C40.7361 83.0858 40.961 82.9682 41.085 82.9897C46.3717 83.9056 48.4829 78.7829 49.0349 75.2371C49.0924 74.8679 49.5589 74.7729 49.7098 75.1147V75.1147C50.6487 77.2401 51.8362 79.1922 51.637 81.6014C51.5651 82.4713 51.2723 83.5472 50.8173 84.3126",
    stroke: "#D5D8DD",
    strokeWidth: 1.07134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4784_17820",
    x1: 46,
    y1: 21,
    x2: 46,
    y2: 69.5981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-stop-color",
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4",
    stopOpacity: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAtlanticCanadaThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AtlanticCanadaThumbnailGray.31ecab7e13ef6dd7273dfa2add0a07df.svg";